/**
 * Configuration for web application
 * Uses centralized JSON config - no environment variables
 */

import { config, getApiBaseUrl } from '@lumora/common';

// Export config values directly
export const SUPABASE_URL = config.supabase.url;
export const SUPABASE_ANON_KEY = config.supabase.anonKey;
export const API_BASE_URL = getApiBaseUrl();
export const ENVIRONMENT = config.environment;

// Legacy ENV object for minimal compatibility (can be removed later)
export const ENV = {
  SUPABASE_URL: config.supabase.url,
  SUPABASE_ANON_KEY: config.supabase.anonKey,
  API_BASE_URL: getApiBaseUrl(),
  NODE_ENV: config.environment,
} as const;

export default ENV;
